export enum Currency {
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
}

export const currencyAsString = (currency: Currency | string): string => {
  switch (currency) {
    case Currency.EUR:
      return "€";
    case Currency.USD:
      return "$";
    case Currency.GBP:
      return "£";
    default:
      return currency;
  }
};

// TODO : @MrWarzo clean ça pcq pabo (adapter avec les currency de stripe)
export const stringToCurrency = (string: string): Currency => {
  switch (string) {
    case "€":
      return Currency.EUR;
    case "$":
      return Currency.USD;
    case "£":
      return Currency.GBP;
    default:
      return Currency.EUR;
  }
};